<template>
    <el-dialog
        title="新增关系"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <el-form
            label-position="right"
            label-width="100px"
            :rules="rules"
            :model="info"
            ref="infoRef">
            <el-form-item label="父节点:" prop="f_node_id">
                <el-select v-model="info.f_node_id" filterable placeholder="请选择">
                    <el-option
                        v-for="item in nodeList"
                        :key="item.id"
                        :label="item.properties.name"
                        :value="item.id">
                        <span>{{item.properties.name}}</span>
                        <span style="color: #ff0000;float: right;">({{layerList[item.properties.layer-1]}})</span>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="子节点:" prop="s_node_id">
                <el-select v-model="info.s_node_id" filterable placeholder="请选择">
                    <el-option
                        v-for="item in nodeList"
                        :key="item.id"
                        :label="item.properties.name"
                        :value="item.id">
                        <span>{{item.properties.name}}</span>
                        <span style="color: #ff0000;float: right;">({{layerList[item.properties.layer-1]}})</span>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="关系名称:" prop="r_name">
                <el-select v-model="info.r_name" placeholder="请选择">
                    <el-option
                        v-for="(item, index) in relationList"
                        :key="index"
                        :label="item"
                        :value="item"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="reset">重 置</el-button>
            <el-button type="primary" @click="addEdge">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "addEdge",
        data() {
            return {
                dialogVisible: false,
                info: {
                    f_node_id: "",
                    r_name: "",
                    s_node_id: ""
                },
                rules: {
                    f_node_id: [
                        {
                            required: true,
                            message: '请选择父节点',
                            trigger: 'blur'
                        }
                    ],
                    s_node_id: [
                        {
                            required: true,
                            message: '请选择子节点',
                            trigger: 'blur'
                        }
                    ],
                    r_name: [
                        {
                            required: true,
                            message: '请选择关系名称',
                            trigger: 'blur'
                        }
                    ]
                },
                // 节点列表
                nodeList: [],
                // 关系列表
                relationList: ["课节", "知识点", "前置知识点", "关联知识点"],
                layerList: ["书", "课节", "知识点", "教学案例"]
            }
        },
        created() {},
        methods: {
            getNodeInfo(res) {
                this.dialogVisible = true;
                this.nodeList = res;
            },
            handleClose() {
                this.dialogVisible = false;
            },
            addEdge() {
                this
                    .$refs['infoRef']
                    .validate((valid) => {
                        if (valid) {
                            if (this.info.f_node_id == this.info.s_node_id) {
                                this
                                    .$message
                                    .warning("首尾节点重复");
                                return false;
                            }
                            this
                                .$http
                                .post("/node/addEdge", this.info)
                                .then((res) => {
                                    if (res.data) {
                                        this
                                            .$refs['infoRef']
                                            .resetFields();
                                        this.$emit("msg", "addEdge");
                                        this.dialogVisible = false;
                                    } else {
                                        this
                                            .$message
                                            .warning("该方向的关系已存在");
                                        return false;
                                    }
                                })
                        } else {
                            this
                                .$message
                                .error("请检查表单信息");
                            return false;
                        }
                    });
            },
            // 表单重置
            reset() {
                this
                    .$refs['infoRef']
                    .resetFields();
            }
        }
    }
</script>

<style>
    .el-form-item {
        margin-bottom: 20px;
    }
    .el-select {
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/subComponents/addEdge.vue